// shadcn/ui standard utility — Tailwind class merge
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { isForbiddenStatus } from '@/lib/error-status';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Jogosultsági hiba felismerése egy react-query `error`-ból. A ts-rest kliens a nem-2xx választ
 * `{ status, body }` objektumként dobja (a queryFn `throw`-ol) — így egy 403 ide kerül. Hálózati/
 * szerver-hiba (throw-olt Error vagy 5xx) NEM jogosultsági hiba → általános hiba-állapot jár.
 * A megjelenítés ez alapján dönt „nincs jogod" vs. „nem sikerült betölteni" között — belső jog-részlet nélkül.
 *
 * ⚠️ A 401 SZÁNDÉKOSAN NINCS BENNE (korábban igen, és ez éles tünetet okozott): a 401 nem jog-ítélet, hanem
 * „a munkamenetedet most nem tudjuk igazolni" — lejárt token vagy elérhetetlen kulcs-készlet. A szabály
 * egyetlen helye és teljes indoklása: `lib/error-status.ts`.
 */
export function isForbiddenError(error: unknown): boolean {
  if (typeof error !== 'object' || error === null || !('status' in error)) return false;
  const { status } = error;
  return isForbiddenStatus(typeof status === 'number' ? status : undefined);
}
